import React from 'react';

import ListingTable from '@components/table/ListingTable';
import { IEnhancedMenuItem } from '@components/table/types';
import { IEnhanceTableHeaderClickable } from '@components/table/widgets/shared-with-old';
import { IListingData } from '@models/listing';

import { amendmentsTableHeaders } from '../../policy/constants';

type Props = {
  tableData: IListingData;
  loading: boolean;
  actions: IEnhancedMenuItem[];
  handlePageChange: (
    page: number,
    keyword?: string,
    rowsPerPage?: number,
    order?: string,
    orderBy?: string
  ) => Promise<void>;
  onOpenAmendment: (row: any) => void;
};

const AmendmentsListingAtom: React.FC<Props> = ({
  tableData,
  loading,
  actions,
  handlePageChange,
  onOpenAmendment
}) => {
  (
    amendmentsTableHeaders.referenceNumber as IEnhanceTableHeaderClickable
  ).callback = onOpenAmendment;

  return (
    <ListingTable
      inlineTitle="Amendments"
      name="amendmentsListing"
      data={tableData}
      headers={amendmentsTableHeaders}
      loader={loading}
      actions={actions}
      inline
      defaultOrderByColumn="createdOn"
      orderByAscendingByDefault={false}
      handleUpdate={handlePageChange}
    />
  );
};

export { AmendmentsListingAtom };
